<template>
  <div>
    <CardedForm
      ref="wards_form_ref"
      id="wards_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <TextField
        v-model="form.name"
        :validation_rules="form_validations.name"
        label="Name Of Ward"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>

      <SelectField
        v-model="form.district_id"
        :options="districts"
        :small_chips="false"
        :validation_rules="form_validations.district_id"
        label="District"
        icon="mdi-pen-plus"
        :disabled="is_loading"
        :is_loading_info="is_loading_info"
        :item_text="'name'"
        :item_value="'id'"
      ></SelectField>

      <SelectField
        v-model="form.city_id"
        :options="cities"
        :small_chips="false"
        :validation_rules="form_validations.city_id"
        label="City"
        icon="mdi-pen-plus"
        :disabled="is_loading"
        :is_loading_info="is_loading_cities_info"
        :item_text="'name'"
        :item_value="'id'"
      ></SelectField>


    </CardedForm>
  </div>
</template>

<script>
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import SelectField from "../../../components/SelectField";
import Utils from "../../../lib/Utils";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminWardsAdd",
  components: {
    CardedForm,
    TextField,
    SelectField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      errors: [],
      message: "",
      form: {
        name: "",
        district_id: null,
        city_id: null
      },
      form_validations: {
        name: [
          Utils.validate.is_required("Ward name is required"),
          Utils.validate.min_max_length(
            2,
            30,
            "Ward name should be between 2 and 30 characters "
          ),
        ],
        district_id: [Utils.validate.is_required("Please select a district")],
        city_id: [Utils.validate.is_required("Please select a city")],
      },
      districts: [],
      is_loading_info: false,
      is_loading_cities_info: false,
      edit_ward_id: 0,
    };
  },
  methods: {
    on_auto_fill() {
      this.init_form();
      var rnd = Math.ceil(Math.random() * 999);
      this.form.name = "ward_name_" + rnd;
      this.form.district_id = 1;
      this.form.city_id = 1;
    },
    init_form() {
      this.form.name = "";
      this.form.district_id = null;
      this.form.city_id = null;
      this.errors = [];
      this.message = "";
      this.$refs.wards_form_ref.on_clear_form();
    },
    submit() {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      if (this.is_editing == true) {
        ServerClient.Locations.update_ward(
          {
            id: this.edit_ward_id,
            ...this.form,
          },
          (res) => {
            console.log("edit wards res", res);
            this.$emit("on-hide-loader");
            this.message =
              "<b>Edit Was Successfull</b> <br/>  Ward has been edited";
            this.$refs.wards_form_ref.show_message_dialog();
          },
          (errors) => {
            console.log("edit wards errors", errors);
            this.errors = errors;
            this.$refs.wards_form_ref.show_error_dialog();
            this.$emit("on-hide-loader");
          }
        );
      } else {
        ServerClient.Locations.post_ward(
          this.form,
          (res) => {
            console.log("add wards res", res);
            this.$emit("on-hide-loader");
            this.message =
              "<b>Operation Was Successfull</b> <br/>  Ward was added";
            this.$refs.wards_form_ref.show_message_dialog();
          },
          (errors) => {
            console.log("add wards errors", errors);
            this.errors = errors;
            this.$refs.wards_form_ref.show_error_dialog();
            this.$emit("on-hide-loader");
          }
        );
      }
    },
    on_hide_message() {
      if (this.is_editing == true) {
        this.$emit("on-success-edit");
      } else {
        this.init_form();
      }
    },
    fill_edit_ward(ward) {
      console.log("ward to be edited ", ward);
      this.edit_ward_id = ward.id;
      this.form.name = ward.name;
      this.form.district_id = parseInt(ward.district_id);
      this.form.city_id = parseInt(ward.city_id);
      this.errors = [];
      this.message = "";
    },
    load_districts() {
      this.is_loading_info = true;
      ServerClient.Locations.get_districts(
        {
          is_drop_down_with_cities: true,
        },
        (res) => {
          this.districts = res;
          this.is_loading_info = false;
        },
        (errors) => {
          this.is_loading_info = false;
          console.log("Errors loading districts on add ward");
        }
      );
    },
  },
  computed:{
    cities(){
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        if(parseInt(district.id) == parseInt(this.form.district_id) ){
          temp = district.cities;
        }
      }
      return temp;
    }
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Add A Ward",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "New Ward",
          disabled: true,
          href: "/admin/locations/wards/add",
        },
      ],
    });
    this.init_form();
    this.load_districts();
  },
};
</script>